"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachmentPhotoIdModelToJSON = exports.AttachmentPhotoIdModelFromJSONTyped = exports.AttachmentPhotoIdModelFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function AttachmentPhotoIdModelFromJSON(json) {
    return AttachmentPhotoIdModelFromJSONTyped(json, false);
}
exports.AttachmentPhotoIdModelFromJSON = AttachmentPhotoIdModelFromJSON;
function AttachmentPhotoIdModelFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ..._1.AttachmentModelFromJSONTyped(json, ignoreDiscriminator),
        'uploadScanStatus': !runtime_1.exists(json, 'uploadScanStatus') ? undefined : _1.DocumentScanStatusEnumFromJSON(json['uploadScanStatus']),
        'scanStatus': _1.DocumentScanStatusEnumFromJSON(json['scanStatus']),
        'scanStatusUpdated': (new Date(json['scanStatusUpdated'])),
    };
}
exports.AttachmentPhotoIdModelFromJSONTyped = AttachmentPhotoIdModelFromJSONTyped;
function AttachmentPhotoIdModelToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ..._1.AttachmentModelToJSON(value),
        'uploadScanStatus': _1.DocumentScanStatusEnumToJSON(value.uploadScanStatus),
        'scanStatus': _1.DocumentScanStatusEnumToJSON(value.scanStatus),
        'scanStatusUpdated': (value.scanStatusUpdated.toISOString()),
    };
}
exports.AttachmentPhotoIdModelToJSON = AttachmentPhotoIdModelToJSON;
//# sourceMappingURL=AttachmentPhotoIdModel.js.map